import { render, staticRenderFns } from "./ToggleFavorite.vue?vue&type=template&id=66476fc3"
import script from "./ToggleFavorite.vue?vue&type=script&lang=js"
export * from "./ToggleFavorite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports